import c from "./lib/createApi";

/**
 * user는 로그인 후 유저 관련
 */
export default {
  me: c("GET", "/v1/user/me", true), // [유저- 1] 유저 획득 및 토큰 발행 테스트, 프로토콜&키리노트 둘다 같은 것 사용
  gets: c("POST", "/v1/user", true),
  test: c("GET", "/v1/user/test-user", false),
  // ==== 프로토콜 에디터 =====
  login: c("POST", "/v1/user/login", true),
  signup: c("POST", "/v1/user", true),
  search: c("GET", "/v1/user/search", true),
  addMemberSearch: c("GET", "/v1/user/addMemberSearch", true),
  mypage: {
    me: c("GET", "/v1/user/mypage", true),
    edit: {
      info: c("PUT", "/v1/user/mypage", true),
      password: c("POST", "/v1/user/mypage/password", true),
    },
    check:{
      password: c("GET", "/v1/user/mypage/password", true),
    },
    process: c("GET", "/v1/user/mypage/process", true),
    protocol: c("GET", "/v1/user/mypage/protocol", true),
    email: c("POST", "/v1/user/mypage/id"),
    passwordConfirm: c("POST", "/v1/user/mypage/passwordConfirm",true),
    getApiKeyList: c("GET", "/v1/user/mypage/apikeys",true),
    saveApiKey: c("POST", "/v1/user/mypage/apikey",true),
    deactivateApiKey: c("PUT", "/v1/user/mypage/apikey",true),
    createApiKey: c("POST", "/v1/user/mypage/create-apikey",true),
  },
  emailAuth:{
    create : c("POST", "/v1/user/createEmailAuthCode"),
    verification : c("POST", "/v1/user/verificationEmailAuthCode"),
  },
  duplicateCheckId: c("POST", "/v1/user/duplicateCheckId"),
  clearIdLock : c("POST", "/v1/user/clearIdLock"),
  updateCompanyCode : c("get", "/v1/user/update/companyCode",true),
};
